import React, { ReactNode, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AppHeader from 'shared/components/Header';
import UserWithTeammatesSidebarSection from 'shared/components/UserWithTeammatesSidebarSection';
import ScoreboardTeamLi from 'shared/components/ScoreboardTeam';
import useUserQueries from 'hooks/query/useUserQueries';
import './styles.scss';
import { useAuth } from 'core/contexts/authContext';
import BurgerMenuButton from 'shared/components/BurgerMenuButton';

type Props = {
  navButtonComponent: ReactNode;
  children: ReactNode;
  showScoreboard?: boolean;
  className?: string;
};

const AppLayout = ({
  navButtonComponent,
  children,
  showScoreboard = true,
  className = '',
}: Props) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { userTeam } = useAuth();
  const { useGetScoreboardTeamsQuery } = useUserQueries();
  const getScoreboardTeamsQuery = useGetScoreboardTeamsQuery({ limit: 3 });
  const teamsData = getScoreboardTeamsQuery.data ?? [];

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <main className={`app-layout ${className}`}>
      <AppHeader navButtonComponent={navButtonComponent} />

      <div className="app-content">
        <div className="mobile-burger-panel">
          <BurgerMenuButton toggleMobileMenu={toggleMobileMenu} />
        </div>

        {/* Оверлей для мобильного меню */}
        {isMobileMenuOpen && (
          <div className="mobile-menu-overlay" onClick={closeMobileMenu} />
        )}

        <aside className={`sidebar ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <div className="sidebar-header-container">
            <div className="sidebar-nav-button-component-container">
              {navButtonComponent}
            </div>

            <div className="sidebar-mobile-burger-panel">
              <BurgerMenuButton toggleMobileMenu={toggleMobileMenu} />
            </div>
          </div>
          <UserWithTeammatesSidebarSection />

          {showScoreboard && (
            <section className="scoreboard">
              {/* "userTeam?.location_name" is used here because the user only receives teams by his location */}
              <h3>{userTeam?.location_name}</h3>
              <ul className="team-rankings">
                {teamsData.map(teamData => (
                  <ScoreboardTeamLi
                    key={teamData.team_name + teamData.session_goal}
                    team={teamData}
                  />
                ))}
              </ul>
              <Link
                to="/scoreboard"
                className="full-scoreboard-link"
                onClick={closeMobileMenu}
              >
                CHECK THE FULL SCOREBOARD HERE
              </Link>
            </section>
          )}
        </aside>

        <div className="main-content">{children}</div>
      </div>
    </main>
  );
};

export default AppLayout;
